module.exports = __webpack_public_path__ + "static/media/product_memory_lcd_2.270278d5.jpg";